<template>
  <div class="w-96 custom-width-1600 bg-theme-primary text-white min-h-screen overflow-y-auto">

    <ModalControl v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error" :question="this.question"
      :success="this.success" :note="this.warning" z_value="z-50" @positiveClick="handleLogout()" :positiveButton="'Yes'" @negativeClick="show_message_modal=false" :negativeButton="'No'"
      :default_width="'max-w-xl'" id='vote_modal'>
      <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center text-gray-600">
        {{ this.modal_message }}
      </div>
    </ModalControl>

    <Loading v-show="loading" :loading="loading" class="z-50"/>
    <div class="flex flex-col justify-between min-h-full">

      <!-- Top: Logo and Menu -->
          <div class="flex-1 flex flex-col">
            <img
              src="https://resource.pafcpic.net/assets/logo/papsi_wordmark.png"
              alt="logo"
              class="mx-auto w-[18rem] pt-10 sm:px-5"
            />
            <div class="mt-10">
              <div
                  v-for="item in items"
                  :key="item.path"
                  @click="navigate(item.path)"
                  :class="[
                    'relative px-6 py-4 cursor-pointer transition flex items-center space-x-3',
                    isActive(item.path)
                      ? 'bg-theme-sidebar-active'
                      : 'hover:bg-theme-sidebar-active'
                  ]"
                >
                
                <div
                  v-if="isActive(item.path)"
                  class="absolute top-2 bottom-2 left-0 w-1.5 bg-theme-secondary rounded-r-md"
                ></div>
                <img :src="item.icon" alt="icon" class="w-6 h-6" />
                <span>{{ item.name }}</span>
                </div>

            </div>
          </div>

          <div class="flex flex-row items-center justify-center gap-2">
            <img
              src="https://resource.pafcpic.net/assets/logo/papsi_iso.png"
              class="h-16 cursor-pointer"
              @click="openImage('https://resource.pafcpic.net/assets/logo/papsi_iso.png')"
              alt="PAPSI ISO"
            >

            <img
              src="https://resource.pafcpic.net/assets/logo/papsi_dp.png"
              class="h-16 cursor-pointer"
              @click="openImage('https://resource.pafcpic.net/assets/logo/papsi_dp.png')"
              alt="PAPSI DP"
            >
          </div>

          <div>
            <div class="w-full flex justify-center items-center p-5 text-xs opacity-40 font-light">
              {{ version }}
            </div>
          </div>
    </div>
    
  </div>
</template>


<script>
import User from "@/services/User";
import mixin from "@/mixin";
import Loading from "@/components/controls/LoadingControl.vue";
import ModalControl from "./ModalControl.vue";

export default {
  name: "SidebarView",
  mixins: [mixin],
  inject: ['setLoading'],
  components: {
    Loading,
    ModalControl
  },
  mounted() {
    this.version = 'Version ' + process.env.VUE_APP_VERSION;
  },
  data() {
    return {
      version: null,
      loading: false,
      show_message_modal: false,
      modal_message: '', 
      error: false,
      question: false,
      success: false,
      warning: false,
      items: [
        { name: 'Dashboard', icon: require('@/assets/images/papsi_dashboard.svg'), path: '/dashboard' },
        { name: 'Profile', icon: require('@/assets/images/papsi_profile.svg'), path: '/user/profile' },
        // { name: 'Online BAEF', icon: require('@/assets/images/papsi_bao.svg'), path: '/services/online-baef' },
        { name: 'Bank Account Opening', icon: require('@/assets/images/papsi_bao.svg'), path: '/bank-account-opening' },
        { name: 'Balance Inquiry', icon: require('@/assets/images/papsi_balances.svg'), path: '/balance-inquiry' },
        { name: 'Services', icon: require('@/assets/images/papsi_service.svg'), path: '/services' },
        { name: 'Events', icon: require('@/assets/images/papsi_events.svg'), path: '/events' },
        { name: 'Settings', icon: require('@/assets/images/papsi_settings.svg'), path: '/user/settings' }
      ]
    };
  },
  methods: {
    openImage(url) {
      window.open(url, '_blank');
    },
    navigate(path) {
      // if (path === '/user/settings') {
      //   this.$store.state.clickedEdit = 'username';
      // }

      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    isActive(path) {
      return this.$route.path.startsWith(path);
    },
    validateLogout() {
      this.question = true;
      this.warning = false;
      this.error = false;
      this.success = false;
      this.modal_message = "Are you sure you want to log out?";
      this.show_message_modal = true;
    },
    handleLogout() {
      const store = this.$store;
      const cookie = this.$cookies;
      const that = this;
      const payload = {
        hash: store.state.credentials.hash
      };
      // this.loading = true;
      that.setLoading(true);
      
      User.logout(payload)
        .then(() => {

          store.state.logged = false;
          store.state.credentials.hash = '';
          cookie.remove('user');
          cookie.remove('user_session');
          this.$router.push('/');
          // this.loading = false;
          that.setLoading(false);
        })
        .catch(() => {
          store.state.logged = false;
          store.state.credentials.hash = '';
          this.$emit('donelogout');
          this.$router.push('/');
          // this.loading = false;
          that.setLoading(false);
        });
    }
  }
};
</script>

<style scoped>
@media (max-width: 1600px) {
  .custom-width-1600 {
    width: 16rem; /* 320px */
  }
}
</style>
